import React from 'react';
import PropTypes from 'prop-types';
import warningAlertLogo from './../../assets/Images/warning-conform-icon.svg'

const LogoutAlert = ({ message, onLogout, onCancel }) => {
  return (
    <div className="logout-alert">
      <div className="logout-alert-content p-4">
        <div className=''><img src={warningAlertLogo} alt="warning" /></div>
        <div className='fnt14 pb-4 pt-2'>{message}</div>
        <button className='btn btn-secondary' onClick={onLogout}>Logout</button>
        <button className='btn btn-primary ms-2' onClick={onCancel}>Cancel</button>
      </div>
    </div>
  );
};

LogoutAlert.propTypes = {
  message: PropTypes.string.isRequired,
  onLogout: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default LogoutAlert;
